<div class="container">
  <nz-spin nzSize="large"></nz-spin>
</div>
